<template>
  <div class="ViewInfo">
    <CenterColumn>

      <h1>
        About The News Machine
      </h1>

      <p>
        The news machine is an educational tool that aims to highlight and give energy to a discussion about source criticism in everyday life and media consumption. It is intended for, study circles, ordinary lessons or for those who want to learn more about contemporary source criticism. Playing the game is estimated to take about 15-30 minutes. You can see a live version in Swedish at www.nyhetsmaskinen.se
      </p>

      <p>
        The tool is made by <a href="http://www.fabel.se" target="_blank">Fabel Kommunikation</a> and <a href="https://www.interaktivarum.se" target="_blank">Interaktiva rum</a> in collaboration with the governmental committee <a href="https://demokratiskasamtalet.se/" target="_blank">National focus on media literacy and the democratic dialogue </a> as well as <a href="https://vardemokrati.se/" target="_blank">The committee for the celebration of 100 years of Democracy in Sweden.</a>
      </p>

      <p>
        All content is licensed by Creative Commons (<a href="https://creativecommons.org/licenses/by-nc-nd/2.5/se/" target="_blank">CC-BY-NC-ND 2.5</a>) and can be used freely for non-commercial applications as long as the creators are mentioned and no changes are made.
      </p>

      <p>
        If your have questions regarding the game please contact us at <a href="mailto:info@fabel.se">info@fabel.se</a>.
      </p>

      <h2>FAQ</h2>
      <h3>
        Hur har ni gjort bedömningarna om nyheterna är sanna eller falska?
      </h3>
      <p>
        I spelet finns en bedömning utifrån sanningshalt. Den värderingen är en samlad bedömning utifrån hur väl nyheten har täckning för vad som skrivs i rubrik och text, om fokus ligger på relevanta fakta och omständigheter för händelser eller om det finns andra element som avser att vilseleda läsaren. Vi förstår dock att detta innehåller gråzoner och vi vill poängtera att detta är en bedömning som vi redogör för i avsnittet “Läs mer om nyheten” vid varje avsnitt.
      </p>

      <h3>
        Hur använder jag Nyhetsmaskinen i klassrummet?
      </h3>
      <p>
		Vi har här tagit fram en kort <a href="https://docs.google.com/document/d/1tHME_tcV4wCXZA9CXGM8_5rCBwUX7J667hQ5MPHW184/edit?usp=sharing" target="_blank">handledning</a> för dig 		som är lärare, för att enklare kunna komma igång med ett gemensamt spel och lärande i klassrumsmiljö. 		
      </p>



      <h2>Resurser</h2>
      <p>
        Vill du lära dig mer om nyhetsgranskning och källkritik är det här bra ställen att kolla på:
        <ul>
          <li>
            <a href="https://statensmedierad.se/larommedier/mikformigdigitalutbildning.1871.html#start" target="_blank">Statens Medieråd</a>
          </li>
          <li>
            <a href="https://internetstiftelsen.se/guide/kallkritik-pa-internet/" target="_blank">Internetstiftelsen</a>
          </li>
          <li>
            <a href="https://mikoteket.se" target="_blank">Mikoteket</a>
          </li>
        </ul>
      </p>

      <ContinueButton @click="home()">Tillbaka till startsidan</ContinueButton>

    </CenterColumn>

  </div>
</template>

<script>

import CenterColumn from '@/components/CenterColumn.vue'
import ContinueButton from '@/components/ContinueButton.vue'

export default {
  name: 'ViewInfo',
  data: function () {
    return {
    }
  },
  components: {
    CenterColumn,
    ContinueButton
  },
  computed: {
  },
  methods: {
    home(){
      this.$router.push({ name: 'Home'})
    }
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>
